import component from './saved.vue'

export default component
